<template>
	<v-list :class="'product-table_' + category">
		<v-list-item
			v-for="(catalogue_product, index) in products"
			:key="'product_' + index"
			@click.native="$emit('editProduct', catalogue_product)"
			:id="catalogue_product.id"
			style="border-bottom: 1px solid #e0e0e0"
		>
			<v-list-item-action>
				<v-icon class="handle"> mdi-cursor-move </v-icon>
			</v-list-item-action>
			<v-list-item-action-text class="mr-3">
				<v-img
					:src="catalogue_product.product_image_url"
					max-width="80"
				></v-img>
			</v-list-item-action-text>
			<v-list-item-content>
				<v-list-item-title>
					{{ catalogue_product.product_name }}
				</v-list-item-title>
				<v-list-item-subtitle>
					{{ catalogue_product.price }}
				</v-list-item-subtitle>
			</v-list-item-content>
			<v-list-item-action>
				<v-switch v-model="catalogue_product.active"></v-switch>
			</v-list-item-action>
		</v-list-item>
	</v-list>
</template>

<script>
import Sortable from "sortablejs";
export default {
	props: ["catalogue_products", "category"],
	data() {
		return {
			products: this.catalogue_products,
		};
	},

	mounted() {
		let table = document.querySelector(".product-table_" + this.category);
		const _self = this;
		Sortable.create(table, {
			handle: ".handle",
			async onUpdate({ item, newDraggableIndex, oldDraggableIndex }) {
				try {
					await axios.post(
						_self.$route("tenant.catalogue_products.sort", {
							tenant: _self.$page.props.tenant.id,
							id: item.id,
							newIndex: newDraggableIndex,
							oldIndex: oldDraggableIndex,
						})
					);
					if (Object.keys(_self.$page.props.errors).length <= 0) {
						_self.$toast.open(
							"Product has been sorted successfully"
						);
					} else {
						_self.$toast.error(
							"Something went wrong while sorting the product"
						);
					}
				} catch (e) {
					_self.$toast.error(e.message);
				}
			},
		});
	},
};
</script>